<template>
  <div>
    <vx-card>
      <ListTipoPagamento :subjectPermission="subjectPermission"></ListTipoPagamento>
    </vx-card>
  </div>
</template>

<script>
import ListTipoPagamento from "./../../lists/ListTipoPagamento";

export default {
  data() {
    return {
      subjectPermission: "Tipo de Pagamento",
    };
  },
  methods: {},
  components: {
    ListTipoPagamento,
  },
};
</script>
